import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	axisYLabel: {
		'id': 'resultAge.axisYLabel',
		'defaultMessage': 'Users age',
	},
	axisXLabel: {
		'id': 'resultAge.axisXLabel',
		'defaultMessage': 'Number of answers',
	},

});


// WEBPACK FOOTER //
// ./src/components/ResultAge/messages.js